/**
 * Cookie Consent Banner JavaScript
 *
 * Handles user interaction with the cookie consent banner,
 * setting consent preferences and reloading when necessary.
 *
 * @package Decisely_Config
 * @since 1.1.0
 */

import Cookies from 'js-cookie';

(function() {
    'use strict';

    /**
     * Initialize cookie consent functionality when DOM is ready.
     */
    function init() {
        const banner = document.getElementById('decisely-cookie-banner');

        // Exit if banner doesn't exist on page.
        if (!banner) {
            return;
        }

        const cookieName = banner.dataset.cookieName || 'STYXKEY_cookie_consent';
        const acceptBtn = document.getElementById('cookie-accept-btn');
        const rejectBtn = document.getElementById('cookie-reject-btn');

        // Cookie options for 30 days, site-wide.
        const cookieOptions = {
            expires: 30,
            path: '/',
            secure: window.location.protocol === 'https:',
            sameSite: 'Lax'
        };

        /**
         * Hide the banner with animation.
         */
        function hideBanner() {
            banner.classList.add('cookie-banner--hiding');

            // Remove banner from DOM after animation completes.
            banner.addEventListener('transitionend', function handler() {
                banner.removeEventListener('transitionend', handler);
                banner.style.display = 'none';
            });
        }

        /**
         * Handle accept button click.
         * Sets consent cookie and reloads page to load tracking scripts.
         */
        function handleAccept() {
            Cookies.set(cookieName, 'accepted', cookieOptions);
            hideBanner();

            // Reload page so PHP can inject tracking scripts.
            // Small delay to allow banner animation to start.
            setTimeout(function() {
                window.location.reload();
            }, 300);
        }

        /**
         * Handle reject button click.
         * Sets rejection cookie without reloading (no scripts to load).
         */
        function handleReject() {
            Cookies.set(cookieName, 'rejected', cookieOptions);
            hideBanner();
        }

        // Bind event listeners.
        if (acceptBtn) {
            acceptBtn.addEventListener('click', handleAccept);
        }

        if (rejectBtn) {
            rejectBtn.addEventListener('click', handleReject);
        }

        // Show banner with animation after a brief delay.
        setTimeout(function() {
            banner.classList.add('cookie-banner--visible');
        }, 100);
    }

    // Initialize when DOM is ready.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
